import React, { Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors } from '../styles';
import { faStar } from '@fortawesome/free-regular-svg-icons'
import { faStar as faStar_Solid } from '@fortawesome/free-solid-svg-icons'

const LevelIndicator = ({level, max=5, color}) =>
{
  let starColor;
  switch(color)
  {
    case "green":
      starColor = colors.green;
      break;
    default:
      break;
  }
  let stars = []
  for (let i = 0; i < max; ++i) {
    stars.push(<FontAwesomeIcon icon={i<level?faStar_Solid:faStar} key={i} color={starColor}/>)
  }
  return (
    <Fragment>
      {stars}
    </Fragment>
  )
}

export default LevelIndicator;